<div class="w-full flex flex-col p-5">
    <h2 class="font-bold">ورود با نام کاربری</h2>

    <div class="w-100 relative gap-2 mt-5">
        <label for="small-test-input" class="w-100">شماره موبایل یا ایمیل</label>
        <!-- (blur)="validatePhoneEmail()" -->
        <input ihoInput size="md" class="w-full {{errValidEmailPhone || msgLogin ? '!border-red-300': 'border-2' }}"
            [(ngModel)]="emailMobile"
             id="small-test-input" type="text"
            placeholder=" مثال: 0912345678 / iho@gmail.com ">
        <p *ngIf="errValidEmailPhone" class="text-red-300 text-xs mt-1">
             ایمیل یا شماره موبایل اشتباه است.
        </p>
    </div>

    <div class="w-100 relative my-3">
        <label for="small-test-input" class="w-100"> رمز عبور </label>
        <div class="relative">
            <!-- (keyup)="validatePhoneEmail()" -->
            <input ihoInput size="md" class="w-full {{errValidPassUser || msgLogin ? '!border-red-300': 'border-2' }}" 
            [(ngModel)]="passUser"
            (keyup.enter)="submitForm()"
           id="small-test-input"
                type="{{showPass ? 'text' : 'password'}}">
            <button (click)="showPass = !showPass" matRipple
                class="input-icon h-8 w-8 flex justify-center items-center rounded-full overflow-hidden">
                <i class="{{showPass ? 'ico-Show' : 'ico-Hide'}} text-muted text-lg"></i>
            </button>
        </div>
        <p *ngIf="errValidPassUser" class="text-red-300 text-xs mt-1">
            فیلد رمز عبور خالی است.
        </p>
    </div>
    
        <p class="text-red-300 text-xs font-bold w-100 relative mt-3" *ngIf="msgLogin">
            {{msgLogin}}
        </p>
    
    <button (click)="emitStep('step-forget-pass')" class="w-full text-right text-sm text-blue-500 my-2 font-bold">
        رمز عبورتان را فراموش کرده اید؟
    </button>


    <button mat-raised-button color="primary" class="w-full"
    [disabled]="!emailMobile && !passUser && (isLoading$ | async)"
    class="!font-bold !text-base !h-11"
    (click)="submitForm()">
        <div class="typing-animation" *ngIf="isLoading$ | async; else defaulText">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <ng-template #defaulText>
            تایید
            و ادامه
        </ng-template>
      
    </button>


</div>